import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';

class Confirmation extends Component {
  constructor() {
    super();
    this._handleCloseConfirmationPopup = this._handleCloseConfirmationPopup.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired,
    _handleSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  
  _handleCloseConfirmationPopup() {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose();
    }
  };

  render() {
    const showCancelButton = this.props.hasOwnProperty('showCancelButton') ? this.props.showCancelButton : true;

    const { _handleSubmit, onClose, cancelLabel, open, title, message, okLabel, submitButtonTheame = "danger" } = this.props;

    return (
      <Modal show={open} onHide={this._handleCloseConfirmationPopup}>
        <Modal.Header closeButton={showCancelButton}>
          <Modal.Title>{title || 'Delete'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="mt0 mb20">{message || 'Are you sure you want to delete ?'}</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle={submitButtonTheame} onClick={_handleSubmit} >
            {okLabel || 'Yes'}
          </Button>
          {' '}
          {showCancelButton && <Button bsStyle="default"
            onClick={onClose}>
            {cancelLabel || 'Cancel'}
          </Button>}
        </Modal.Footer>
      </Modal>
    )
  };
}

export default Confirmation;
